module.exports = __webpack_public_path__ + "img/LinkedIn.fe556bf7.svg";